__turbopack_context__.v({
  "like_symbol": "styles-module__UsOVxa__like_symbol",
  "percentage_liked": "styles-module__UsOVxa__percentage_liked",
  "total_ratings": "styles-module__UsOVxa__total_ratings",
});
